import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconPlatformAppleSvg } from "./IconPlatformAppleSvg.mjs";
const IconPlatformApple = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconPlatformAppleSvg, ...svgProps }) });
export {
  IconPlatformApple
};
